import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { TrendingUp } from 'lucide-react';

interface Props {
  score: number;
  trend30d: number;
  compact?: boolean;
}

export function SecurityScoreGauge({ score, trend30d, compact = false }: Props) {
  const data = [
    { name: 'score', value: score },
    { name: 'remain', value: 100 - score },
  ];

  return (
    <div className={compact ? 'relative rounded-md border border-[#19395a] bg-[#071d31] px-3 py-2' : 'card relative'}>
      <div className="flex items-center gap-1.5 text-[11px] font-semibold text-[#dbe7f3]">
        Security Score <span className="grid h-3.5 w-3.5 place-items-center rounded-full border border-[#365470] text-[9px] text-[#8fa1b8]">i</span>
      </div>
      <div className="grid grid-cols-[61%_39%] items-center min-h-[98px]">
        <div className="relative h-[98px]">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                startAngle={180}
                endAngle={0}
                cx="50%"
                cy="92%"
                innerRadius={50}
                outerRadius={62}
                stroke="none"
                isAnimationActive={false}
              >
                <Cell fill={scoreColor(score)} />
                <Cell fill="#33445d" />
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <div className="absolute inset-x-0 bottom-0 text-center pointer-events-none">
            <div className="inline-flex items-baseline justify-center gap-1">
              <span className="text-[34px] leading-none font-extrabold tracking-tight" style={{ color: scoreColor(score) }}>{score}</span>
              <span className="text-[13px] text-[#b4c0cd]">/100</span>
            </div>
            <div className="text-[11px] text-good font-semibold mt-1">Excellent</div>
          </div>
        </div>
        <div className="border-l border-[#19395a] pl-3 text-[11px]">
          <div className="flex items-center gap-1 text-good text-[15px] font-extrabold leading-none">
            <TrendingUp className="w-3.5 h-3.5" /> +{trend30d}
          </div>
          <div className="mt-2 text-[#91a3b8]">vs last 30 days</div>
        </div>
      </div>
    </div>
  );
}

function scoreColor(s: number) {
  if (s >= 90) return '#22C55E';
  if (s >= 70) return '#F59E0B';
  return '#EF4444';
}
